import { Component, computed, inject } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { LoginComponent } from '../login/login.component';
import { QueryFormComponent } from '../../components/query-form/query-form.component';
import { PageLayoutComponent } from '../../components/page-layout/page-layout.component';
import { QueueStatsComponent } from '../../components/queue-stats/queue-stats.component';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [LoginComponent, QueryFormComponent, PageLayoutComponent, QueueStatsComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {
  private auth = inject(AuthService);
  readonly authResolved = this.auth.authResolved;
  readonly isAuthenticated = this.auth.isAuthenticated;
  readonly user = this.auth.user;
  readonly displayName = computed(() => this.user()?.email || 'user');
}
